import type { DirectiveBinding } from "vue";

const duration = 500; // 롱프레스 시간 설정

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("longpress", {
    beforeMount(el: HTMLElement, binding: DirectiveBinding) {
      // 바인딩 값이 함수가 아닌 경우 경고 메시지 출력
      if (typeof binding.value !== "function") {
        console.warn(
          `[v-longpress] binding value must be a function, got ${typeof binding.value}`
        );
        return;
      }

      let pressTimer: number | null = null;

      // 롱클릭 시작 시 동작할 함수
      const start = (e: MouseEvent | TouchEvent) => {
        // 마우스 이벤트인 경우 왼쪽 버튼만 반응하도록 처리
        if (
          (e as MouseEvent).type === "mousedown" &&
          (e as MouseEvent).button !== 0
        ) {
          return;
        }
        if (pressTimer === null) {
          pressTimer = window.setTimeout(() => {
            binding.value(e);
          }, duration); // 1000밀리초(1초) 후 실행, 필요시 시간 조정 가능
        }
      };

      // 롱클릭 취소 시 동작할 함수
      const cancel = () => {
        if (pressTimer !== null) {
          clearTimeout(pressTimer);
          pressTimer = null;
        }
      };

      // 마우스 및 터치 이벤트에 대해 이벤트 리스너 등록
      el.addEventListener("mousedown", start);
      el.addEventListener("touchstart", start, { passive: true });
      el.addEventListener("mouseup", cancel);
      el.addEventListener("mouseleave", cancel);
      el.addEventListener("touchend", cancel);
    },
  });
});
